export enum GiveawayType {
  GIVEAWAY = 'GIVEAWAY',
  DUE_DILIGENCE = 'DUE_DILIGENCE',
}
